import React from 'react';
import { Link } from 'react-router-dom';
import { Alert, AlertTitle, Tooltip } from '@mui/material';
import { ROUTES } from '../../../Router';

const SubscriptionAlert = (props) => {
    const { severity, title, prefixMessage, suffixMessage, actionText } = props;

    return (
        <Alert severity={severity}>
            {title ? <AlertTitle>{title}</AlertTitle> : null}
            {prefixMessage}{' '}
            <Tooltip title={`Click to subscription page`} arrow placement="top">
                <Link to={ROUTES.PRICING}>{actionText}</Link>
            </Tooltip>{' '}
            {suffixMessage}
        </Alert>
    );
};

export default SubscriptionAlert;
